import { useIntl } from "react-intl";

const ConfigurableWorkflows = () => {
    const intl = useIntl();
    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ConfigurableWorkflows.header",
            defaultMessage: "Configurable workflows"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ConfigurableWorkflows.body",
            defaultMessage:
                "Configure your request forms and associated workflows with easy-to-use fields that let you drag and drop."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default ConfigurableWorkflows;
